
import BaseControlView from 'BaseControlView';
import eventBus         from 'EventBus';
import template from 'advanced-visuals/control-link.ejs';
import constants        from "Constants";
//=====================================================================
//
// An instance of this view represents a hypertext control.
//
// Rene Lopez, March, 1 2016
//
//=====================================================================
class LinkControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.propViews = opts.propViews;

        this.events={
            'dblclick div.pf-control':'handleDblClick'
        };

        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, 'linkThemeChange', this.themeChangeRender);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
        return this;
    }


    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'LinkControlView';
    }
}

export default LinkControlView;

